import { useContext } from "react";
import { IntlShape, useIntl } from "react-intl";
import styled from "styled-components";
import { actionHandlers } from "@cayo/shared/scheme/actions";
import { ProductContext, SubscriptionEnum } from "../../../contexts/product-context";
import { GradientButton } from "../gradientButton";
import { freemiumMessages } from "../messages";

function getDaysLeftText(expirationDateTime: string, intl: IntlShape): string {
  const now = new Date();
  const expiration = new Date(expirationDateTime);

  const diffTime = expiration.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    return intl.formatMessage(freemiumMessages.expired);
  }

  return intl.formatMessage(freemiumMessages.daysLeft, {
    days: diffDays,
  });
}

export const PlanInfo = () => {
  const intl = useIntl();
  const product = useContext(ProductContext);

  const isFree = product?.subscriptionType === SubscriptionEnum.free;
  const isTrial = product?.subscriptionType === SubscriptionEnum.trial;

  const hasExpiredTrial = product?.subscriptions?.find(
    (s) => s.licenseType === SubscriptionEnum.trial && s.status === "expired"
  );
  const activeSubscription = isTrial
    ? product?.subscriptions?.find((s) => s.licenseType === SubscriptionEnum.trial)
    : null;

  if (product?.subscriptionType === SubscriptionEnum.paid) {
    return null;
  }

  return (
    <Container>
      <Header>
        <Title>
          {isFree
            ? intl.formatMessage(freemiumMessages.free)
            : intl.formatMessage(freemiumMessages.trialPlan)}
        </Title>
        {isTrial && activeSubscription && (
          <DaysLeft>{getDaysLeftText(activeSubscription.expirationDateTime, intl)}</DaysLeft>
        )}
      </Header>
      <a href={"https://www.cayosoft.com/products/guardian"} target="_blank" rel="noreferrer">
        {intl.formatMessage(freemiumMessages.learnProducts)}
      </a>

      <GradientButton
        onClick={() => {
          if (isFree && !hasExpiredTrial) {
            return actionHandlers["show.wizard"]("product-activation,reloadAfterClose");
          }

          window.open("https://cayosoft.com/get-a-license");
        }}
        text={
          isFree
            ? intl.formatMessage(freemiumMessages.upgrade)
            : intl.formatMessage(freemiumMessages.update)
        }
        icon={isFree ? "favoriteStar" : undefined}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #f0f8ff;
  border-radius: 4px;
  padding: 12px 16px;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 4px;
`;

const Title = styled.span`
  font-size: 14px;
`;

const DaysLeft = styled.span`
  font-size: 13px;
  color: #444;
`;
